import SkeletonLoader from './skeleton.vue.js';
import Feather from './feather.vue.js';
import Material from './material.vue.js';

var script = {
  name: 'Loading',
  components: {
    Skeleton: SkeletonLoader,
    Feather,
    Material
  },
  data() {
    return {
      visible: false,
      hiding: false,
      containerWidth: 0,
      containerHeight: 0
    };
  },
  computed: {
    overlayStyle() {
      const {
        type,
        spinnerProps,
        overlayProps
      } = this;
      if (type === 'skeleton') {
        return {
          position: overlayProps.position || 'absolute'
        };
      }
      return {
        'background-color': spinnerProps.background,
        'position': overlayProps.position || 'absolute',
        'justify-content': 'center',
        'grid-gap': '8px'
      };
    }
  },
  methods: {
    setContainerSize(_ref) {
      let {
        width,
        height
      } = _ref;
      this.containerHeight = height;
      this.containerWidth = width;
    }
  }
};

export { script as default };
//# sourceMappingURL=loading.vue2.js.map
